import gql from 'graphql-tag';

const NOTIFICATION_FRAGMENT = gql`
  fragment NotificationFragment on NotificationPayload {
    unread
    count
    pageCount
    notification {
      _id
      key
      payload
      read
      createdAt {
        timestamp
      }
    }
  }
`;

export const FETCH_NOTIFICATION_QUERY = gql`
  query fetchNotification($read: Boolean, $paginationInput: PaginationInput!) {
    fetchNotification(read: $read, page: $paginationInput) {
      ...NotificationFragment
    }
  }
  ${NOTIFICATION_FRAGMENT}
`;

export const NOTIFICATION_MARK_READ_MUTATION = gql`
  mutation notificationMarkRead($notification: [ID]!) {
    notificationMarkRead(notification: $notification) {
      _id
    }
  }
`;

export const NOTIFICATION_ADDED_SUBSCRIPTION = gql`
  subscription notificationAdded($user: ID!) {
    notificationAdded(_user: $user) {
      _id
      key
      payload
      read
      createdAt {
        timestamp
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/modules/notification/api.js